var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'o-container--bleed' : _vm.isFirstBlock}},[_c('ImageTextVideoBlockNew',{attrs:{"content":_vm.content,"width-on-screen":100,"aspect-ratio":1440/480,"is-hero-banner":true,"is-first-block":_vm.isFirstBlock}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }